import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearCurrentSeries, loadCurrentSeriesForProject } from '@/store/slices/series';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const useLoadCurrentSeries = () => {
  const { projectUuid } = useParams();
  const channel = useAppSelector(getActiveChannel);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (projectUuid && channel) {
      dispatch(
        loadCurrentSeriesForProject({
          channel,
          eventUuid: projectUuid,
        })
      );
    } else {
      dispatch(clearCurrentSeries());
    }
  }, [projectUuid, channel, dispatch]);
};
